module.exports = __webpack_public_path__ + "img/ico-grade-red.bc52be06.svg";